<template>
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <WelcomeCard />
        </div>
      </div>

      <div class="col-xl-12">
        <div class="card" v-if="!event_partner">loading...</div>
        <div class="card" v-if="event_partner">
          <div class="card-header card-no-border">
            <div class="header-top">
              <b class="m-0">Activities you've create with us</b>
            </div>
          </div>
          <div class="card-body pt-0 campaign-table">
            <div class="table-responsive currency-table">
              <table class="table" >
                <thead>
                  <tr>
                    <th >Event</th>
                    <th style="text-align: center">SETTING</th>
                    <th style="text-align: center">REPORT</th>
                    <th style="text-align: center">DRIVE</th>
                    <!-- <th style="text-align: center">LINE</th> -->
                    <!-- <th style="text-align: left">HL</th> -->
                    
                    <th style="text-align: center">#1</th>
                    <th style="text-align: center">#2</th>
                    <th v-if="this.user.role_name==='systemadmin'" style="text-align: center">COUPON</th>


                    
                  </tr>
                </thead>
                <tbody
                  v-if="this.is_loading === 'N' && event_partner.length === 0"
                >
                  <tr>
                    <td colspan="5">
                      <div class="d-flex justify-content-center" >
                        There are no activities currently open with us.
                      </div>
                      <div class="d-flex justify-content-center" >
                        You can contact us and activate the search system at any time...
                        
                      </div>
                      <div class="d-flex justify-content-center" >
                        You're also welcome to try out the system first &nbsp;<i class="fa fa-heart" style="font-size:10px;color:red"></i>
                        
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-if="this.is_loading === 'Y' && event_partner.length === 0"
                >
                  <tr>
                    <td colspan="10">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 30px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tbody v-if="event_partner.length !== 0">
                  <template v-for="event in event_partner" :key="event">
                    <tr>
                      <td style="padding: 7px;font-size: 13px;">
                        [{{ event.event_date_text }}]&nbsp;{{ event.title }}
                      </td>
                      <td style="text-align: center;padding: 7px;font-size: 12px;">
                        <a v-if="user.role_name === 'system'||user.role_name === 'systemadmin'" :href="'/event-adjustment-admin/' + event.event_key">setting</a>
                        <a v-else :href="'/event-adjustment/' + event.event_key">setting</a>
                      </td>
                      <td style="text-align: center;padding: 7px;font-size: 12px;"><a :href="'/order-admin/' + event.event_key">report</a></td>
                      
                      <td style="text-align: center;padding: 7px;font-size: 12px;" v-if="event.google_drive === ''">-</td>
                      <td style="text-align: center;padding: 7px;font-size: 12px;" v-if="event.google_drive !== ''"><a target="_blank" :href="event.google_drive" >drive</a></td>

                      <!-- <td style="text-align: center" v-if="event.line_group === ''">-</td>
                      <td style="text-align: center;padding: 7px;font-size: 12px;" v-if="event.line_group !== ''"><a target="_blank" :href="event.line_group" >group</a></td> -->
                      
                      <!-- <td style="padding: 7px;font-size: 12px;"><a :href="'/upload_hl/' + event.event_key">upload</a> </td> -->


                      <td style="text-align: center;font-size: 12px;" >
                        <vue-feather size="17px"  v-if="event.is_cut_round1 === 'Y'" type="check-circle" stroke="green" ></vue-feather>
                        <vue-feather size="17px" v-if="event.is_cut_round1 === 'N'" type="circle"></vue-feather>
                      </td>
                      <td style="text-align: center;font-size: 12px;" >
                        <vue-feather size="17px" v-if="event.is_cut_round2 === 'Y'" type="check-circle" stroke="green" ></vue-feather>
                        <vue-feather size="17px" v-if="event.is_cut_round2 === 'N'" type="circle"></vue-feather>
                      </td>
                      <td style="font-size: 12px;text-align: left"> <a :href="'/coupon/' + event.event_key" v-if="this.user.role_name==='systemadmin'">coupon</a> </td>
                    </tr>
                    
                    <!-- Progress Bar Row -->
                    <tr>
                      <td colspan="7" style="padding: 0; border-top: none;">
                        <div class="progress-container">
                          <div class="progress-bar-custom">
                            <div 
                              class="progress-fill" 
                              :style="{
                                width: getProgressWidth(event.event_date),
                                backgroundColor: getProgressColor(event)
                              }"
                            ></div>
                            <div 
                              class="checkpoint checkpoint-1" 
                              :class="{ 'active': isCheckpoint1Passed(event.event_date) }"
                            >
                              <span class="checkpoint-label">10d</span>
                            </div>
                          </div>
                          <div class="progress-info">
                            <small>{{ getDaysRemaining(event.event_date) }}</small>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.disabled {
  opacity: 0;
  pointer-events: none;
}

.progress-container {
  width: 100%;
  position: relative;
  padding: 5px 15px;
}

.progress-bar-custom {
  width: 100%;
  height: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
  position: relative;
  background: linear-gradient(90deg, 
    rgba(255,255,255,0.3) 0%, 
    transparent 50%, 
    rgba(255,255,255,0.3) 100%
  );
  background-size: 200% 100%;
  animation: progressShimmer 2s infinite linear;
}

@keyframes progressShimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.checkpoint {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #39d400;
  border: 2px solid #9b9b9b;
  z-index: 2;
}

.checkpoint.active {
  border-color: #a0a0a0;
  background-color: #ffffff;
}

.checkpoint-1 {
  left: 33.33%;
  transform: translateX(-50%) translateY(-50%);
}

.checkpoint-label {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 10px;
  font-weight: 400;
  white-space: nowrap;
  color: #8c8c8c;
}

.progress-info {
  text-align: right;
  margin-top: 4px;
  font-size: 10px;
  color: #666666;
}

.feather {
  width: 10px;
  height: 10px;
}
</style>

<script>
import axios from "axios";
export default {
  data() {
    return {
      event_partner: [],
      is_loading: "N",
      loading: true,
      user: {},
      token: localStorage.getItem("jwt")
    };
  },
  async created(){
    this.token = localStorage.getItem("jwt")
  },
  async mounted() {
    this.is_loading = "Y";
    try {
      this.user = JSON.parse(localStorage.getItem("user"));
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post("/v1/partner/event-partner",null, {
        headers
      });

      if (response.data.status === "success") {
        this.event_partner = response.data.body;
        this.is_loading = "N";
        this.loading = false;
      } else {
        alert("พบข้อผิดพลาดกรุณา logout และ login อีกครั้งหรือติดต่อผู้ดูแลระบบ")
        //this.$router.push({ path: "/auth/login" });
      }
    } catch (error) {
      //this.$router.push({ path: "/auth/login" });
    }
  },
  methods: {
    isCheckpoint1Passed(eventDate) {
      // Check if current date >= event_date + 10 days
      const today = new Date();
      const eventDateObj = new Date(eventDate);
      const checkpoint1Date = new Date(eventDateObj);
      checkpoint1Date.setDate(eventDateObj.getDate() + 10);
      return today >= checkpoint1Date;
    },
    isCheckpoint2Passed(eventDate) {
      // Check if current date >= event_date - 30 days
      const today = new Date();
      const eventDateObj = new Date(eventDate);
      const checkpoint2Date = new Date(eventDateObj);
      checkpoint2Date.setDate(eventDateObj.getDate() - 30);
      return today >= checkpoint2Date;
    },
    isEventDatePassed(eventDate) {
      // Check if current date >= event_date
      const today = new Date();
      const eventDateObj = new Date(eventDate);
      return today >= eventDateObj;
    },
    getProgressWidth(eventDate) {
      const today = new Date();
      const eventDateObj = new Date(eventDate);
      
      // Calculate days passed since event date
      const diffTime = today - eventDateObj;
      const daysPassed = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      // If event hasn't happened yet, progress is 0%
      if (daysPassed <= 0) {
        return '0%';
      }
      
      // If more than 30 days have passed, progress is 100%
      if (daysPassed >= 30) {
        return '100%';
      }
      
      // Calculate progress as percentage of 30 days
      const progressPercent = (daysPassed / 30) * 100;
      
      return progressPercent + '%';
    },
    getProgressColor(event) {

      if(event.is_mhao !== 'Y'){
        return '#d1d1d1'; // ant design red - not started
      }
      const today = new Date();
      const eventDateObj = new Date(event.event_date);
      const checkpoint1Date = new Date(eventDateObj);
      checkpoint1Date.setDate(eventDateObj.getDate() + 10);
      
      // Calculate days passed since event date
      const diffTime = today - eventDateObj;
      const daysPassed = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      // If event hasn't happened yet, show gray
      if (daysPassed <= 0) {
        return '#d9d9d9'; // ant design gray - not started
      }
      
      // If passed 10 days and is_cut_round1 is 'N', show red
      if (daysPassed >= 10 && event.is_cut_round1 === 'N') {
        return '#ff4d4f'; // ant design red
      }
      
      // Show different colors based on progress
      if (daysPassed >= 30) {
        return '#52c41a'; // ant design green - completed
      } else if (daysPassed >= 10) {
        return '#1890ff'; // ant design blue - after checkpoint
      } else {
        return '#13c2c2'; // ant design cyan - in progress
      }
    },
    getDaysRemaining(eventDate) {
      const today = new Date();
      const eventDateObj = new Date(eventDate);
      const diffTime = today - eventDateObj;
      const daysPassed = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      if (daysPassed <= 0) {
        return 'Event not started';
      } else if (daysPassed <= 30) {
        return `${daysPassed}/30 days passed`;
      } else {
        return 'Period completed';
      }
    }
  }
};
</script>
